module.exports = __webpack_public_path__ + "img/horizontal_7_4_6000.6b6246d6.png";